import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'collection',
	prefix: 'collection',
	key: 'collection_id',
	fields: {
		collection_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		game_version_id: Model.SCHEMA_NUMBER,
		collection_date_updated: Model.SCHEMA_NUMBER,
		collection_date_owned: Model.SCHEMA_NUMBER,
		collection_date_acquired: Model.SCHEMA_NUMBER,
		collection_expansion: Model.SCHEMA_NUMBER,
		collection_nested: Model.SCHEMA_NUMBER,
		collection_nested_official: Model.SCHEMA_NUMBER,
		collection_nested_custom: Model.SCHEMA_NUMBER,
		collection_own: Model.SCHEMA_NUMBER,
		collection_prevowned: Model.SCHEMA_NUMBER,
		collection_fortrade: Model.SCHEMA_NUMBER,
		collection_want: Model.SCHEMA_NUMBER,
		collection_wanttoplay: Model.SCHEMA_NUMBER,
		collection_wanttobuy: Model.SCHEMA_NUMBER,
		collection_wishlist: Model.SCHEMA_NUMBER,
		collection_preordered: Model.SCHEMA_NUMBER,
		collection_hasparts: Model.SCHEMA_NUMBER,
		collection_wantparts: Model.SCHEMA_NUMBER,
		collection_hasparts_text: Model.SCHEMA_TEXT,
		collection_wantparts_text: Model.SCHEMA_TEXT,
		collection_condition_text: Model.SCHEMA_TEXT,
		collection_plays: Model.SCHEMA_NUMBER,
		collection_rating: Model.SCHEMA_NUMBER,
		collection_wishlist_priority: Model.SCHEMA_NUMBER,
		collection_wishlist_comment: Model.SCHEMA_TEXT,
		collection_value: Model.SCHEMA_NUMBER,
		collection_private_location: Model.SCHEMA_TEXT
	}
})
